
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import Loader from 'examples/Loader';
import Pricing from './Pricing';
import SettingTab from './SettingTab';
import PotentialPricing from './PotentialPricing';
import Tabs from "../components/Tabs"
import CreateModal from "./components/CreateModal/index";

import { useAgencySaasProducts, usePotentialSaasProducts } from "queries/saas";
import Coupons from "./Coupons";
import AITaskTokens from "./AITaskTokens";

function Saas() {
  const [value, setValue] = useState(0);
  const queryClient = useQueryClient();
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false)
  const [prices, setPrices] = useState([])

  const { data: productsResponse, isLoading: productsLoading } = useAgencySaasProducts(agency._id);
  const products = productsResponse?.data;

  const { data: potentialproducts, isLoading: potentialProductsLoading } = usePotentialSaasProducts(agency._id);

  const Load = productsLoading || potentialProductsLoading;
  // Kept the same name/no-arg contract CreateModal and Pricing already call
  // as handleRefresh - now just a cache invalidation instead of a refetch.
  const onLoad = () => queryClient.invalidateQueries({ queryKey: ["saas"] });

  return (
    <>
      {Load ?
        <Loader />
        :
        <div className='pt-0 p-5'>
          <div style={{ width: "100%", position: "relative" }} className='d-flex justify-content-between'>
            <h2 style={{ width: "50%", padding: "20px 0px" }}  >SaaS Configurator</h2>
            <div style={{
              width: "50%", marginTop: "105px", textAlign: "right", textAlign: "right",
              position: "absolute",
              right: 13
            }}>
              <div className="d-flex justify-content-end">
                <button

                  className="btn-new-design-black"
                  onClick={() => setOpen(true)}
                >
                  Add SaaS Plan
                </button>
                {open && <CreateModal open={open} onClose={() => setOpen(false)} prices={prices} handleRefresh={onLoad} />
                }
              </div>
            </div>
          </div>
          <Tabs tabsData={[
            { label: 'Price and planing', content: <Pricing data={products} potentialproducts={potentialproducts} handleRefresh={onLoad} /> },
            { label: 'Advanced Settings', content: <SettingTab /> },
            { label: 'Coupons', content: <Coupons products={products} /> },
            { label: 'Bulk AI Task ', content: <AITaskTokens /> },
          ]} />


        </div>
      }

    </>
  );
}

export default Saas;